import type { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    // Brand
    colorPrimary: "#0062cc",

    // Fallback
    fontFamily: "Inter, sans-serif",

    // Text
    colorText: "#1A1A1A",
    colorTextSecondary: "#333",
    colorTextTertiary: "#999",
    colorTextPlaceholder: "#CCC",

    // Control
    controlHeight: 48,
    controlHeightSM: 40,
    controlHeightLG: 52,

    // Background
    colorBgContainer: "#ffffff",

    // Radius
    borderRadius: 12,
    borderRadiusLG: 16,

    // Typography
    fontSize: 14,
    fontSizeLG: 16,

    // Button
    colorTextDisabled:
      "color-mix(in oklch, oklch(0.3211 0 0) 48%, transparent)",
  },
  components: {
    Input: {
      hoverBorderColor: "#0062cc",
      activeBorderColor: "#0062cc",
    },
    Form: {
      labelColor: "#999",
      itemMarginBottom: 16,
    },
    Button: {
      defaultBg: "#fec107",
      defaultColor: "#1A1A1A",
      defaultHoverBg: "#e0a800",
      defaultHoverColor: "#1A1A1A",
      defaultBgDisabled:
        "color-mix(in oklch, oklch(0.8431 0.1719 85.32) 48%, transparent)",

      fontWeight: 700,
      lineWidth: 0,
    },
    Card: {
      bodyPaddingSM: 16,
    },
  },
};
